import React from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./XCube.css";

import X1bg from "../assets/image/X1bg.png";
import X1_1 from "../assets/image/X1_1.png";
import X1_2 from "../assets/image/X1_2.png";
import X1_3 from "../assets/image/X1_3.png";
import X2bg from "../assets/image/X2bg.png";
import X2_1 from "../assets/image/X2_1.jpg";
import X2_2 from "../assets/image/X2_2.png";
import X2_3 from "../assets/image/X2_3.png";
import X3bg from "../assets/image/X3bg.png";
import X3_1 from "../assets/image/X3_1.png";
import X3_2 from "../assets/image/X3_2.png";

function XCube() {
  return (
    <div>
      <Helmet>
        <title>Animatronics, Show Set, Scenic| Riocube Engineering</title>
        <meta
          name="description"
          content="Specializes in the design and construction of animated and scenic show sets, as well as special effects."
        />
        <meta name="keywords" content="" />
      </Helmet>

      <Header />

      <section
        className="hero-banner-X-1"
        style={{ backgroundImage: `url(${X1bg})` }}
      >
        <div className="overlay-X-1">
          <h1>Animatronics</h1>
          <p>
            Animatronics characters gives the magical touch to any shows,
            blowing audiences minds while creating emotional and lasting
            experiences.
          </p>
        </div>

        <div className="animatronics-container">
          <div className="title-section">
            <div className="category-tags">
              <span className="tag">Animatronic</span>
              <span className="tag">Animated Prop</span>
              <span className="tag">Animated Sculptures</span>
              <span className="tag">Show Action Equipment</span>
            </div>
          </div>

          <div className="content-grid">
            <div
              className="main-display"
              style={{
                backgroundImage: `url(${X1_1})`,
                backgroundSize: "COVER",
              }}
            ></div>

            <div className="side-gallery">
              <div
                className="gallery-item prop-1"
                style={{
                  backgroundImage: `url(${X1_2})`,
                  backgroundSize: "COVER",
                }}
              ></div>
              <div
                className="gallery-item prop-2"
                style={{
                  backgroundImage: `url(${X1_3})`,
                  backgroundSize: "COVER",
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="hero-banner-X-2"
        style={{ backgroundImage: `url(${X2bg})` }}
      >
        <div className="overlay-X-2">
          <h1>Scenic</h1>
          <p>
            The ability to create scene that lives up to the storytelling and
            creative standard that bring the guests through the magical
            experience that will last their lifetime
          </p>
        </div>
        <div className="animatronics-container-2">
          <div className="title-section-2">
            <div className="category-tags-2">
              <div className="column">
                <span className="tag">Show Sets</span>
                <span className="tag">Sculpture</span>
                <span className="tag">Props</span>
              </div>
              <div className="column">
                <span className="tag">Theme Paint</span>
                <span className="tag">Marquee</span>
                <span className="tag">Directional</span>
              </div>
            </div>
          </div>

          <div className="content-grid-2">
            <div className="side-gallery-2">
              <div
                className="gallery-item-2 prop-1"
                style={{
                  backgroundImage: `url(${X2_2})`,
                  backgroundSize: "COVER",
                }}
              ></div>
              <div
                className="gallery-item-2 prop-2"
                style={{
                  backgroundImage: `url(${X2_3})`,
                  backgroundSize: "COVER",
                }}
              ></div>
            </div>
            <div
              className="main-display-2"
              style={{
                backgroundImage: `url(${X2_1})`,
                backgroundSize: "COVER",
              }}
            ></div>
          </div>
        </div>
      </section>

      <section
        className="hero-banner-X-3"
        style={{ backgroundImage: `url(${X3bg})` }}
      >
        <div className="overlay-X-3">
          <h1>Effects</h1>
          <p>
            Effects seems like a small part in an attraction, but the presence
            create a lasting and life like scene to amaze the guests.
          </p>
        </div>
        <div className="title-section-3">
          <div className="category-tags-3">
            <div className="column-3">
              <span className="tag">Lighting FX</span>
              <span className="tag">Water FX</span>
            </div>
            <div className="column-3">
              <span className="tag">Smoke FX</span>
              <span className="tag">Scents FX</span>
              <span className="tag">Fire FX</span>
            </div>
            <div className="column-3">
              <span className="tag">Sound FX</span>
              <span className="tag">Media</span>
            </div>
          </div>
        </div>
        <div
          className="main-display-3-1"
          style={{
            backgroundImage: `url(${X3_2})`,
            backgroundSize: "COVER",
          }}
        ></div>
        <div
          className="main-display-3-2"
          style={{
            backgroundImage: `url(${X3_1})`,
            backgroundSize: "COVER",
          }}
        ></div>
      </section>

      <Footer />
    </div>
  );
}

export default XCube;
